<template>
    <div class="admin-tols">
        <div class="admin-menu-tols">
            <button @click="editSkelet">Изменить</button>
            <button @click="addSkelet" v-if="false">Добавить</button>
            <button>Удалить</button>
            <button @click="up" >Вверх</button>
            <button @click="down">Вниз</button>
        </div>
        <modal-form v-if="showForm">
            <h2>{{title}}
               {{ params[0] }}
               {{ skelet }}
            </h2><button @click="e=>{this.tab = 'Предпросмотр';this.showForm = false}" class="close"></button>
             <select-ms v-model="skelet" :disabled="disabledSkilet">
                <option 
                    v-for="item in arraySkelet" 
                    :key="item.id" 
                    :value="item.text_id">
                    {{ item.text }}
                </option>
            </select-ms> 
            <tabs-ms :tabs="tabs" @click="tabClick" :value="tab">
                <div  v-show="tab == 'Предпросмотр'">
                    <div v-if="skelet == 'HR'">
                        <h3>
                            {{params[1].text}} {{params[1].tel}} {{params[1].FIO}}
                        </h3>
                    </div>
                    <component 
                        :save="remove"
                        :ref="(el) => {this.refs = el}"
                        :is="skelet"               
                        :params="params[1]">
                    </component>  
                </div> 
                <div  v-if="tab == 'Настройки'">
                    <component 
                        :is="adskelet"               
                        :params="params[1]"
                        :id="params[2]"
                        :data-com="this.refs?.$data"
                        :save="inSave"
                        @on-save="remove = !remove;this.tab = 'Предпросмотр';">
                    </component> 
                </div>
            </tabs-ms>

            <div class="admin__button">
                <button  @click="save">Схранить</button>
                <button @click="this.showForm =  false">Отмена</button>
            </div>        
        </modal-form>
    </div>
</template>
<script>
import axios from 'axios';
import modalForm from '../common/modalFormMs.vue'
import selectMs from '../common/selectMs.vue'
import tabsMs from '../common/tabsMs.vue'
import components from '@/mixins/components.mixin.js';
import admin from '@/mixins/components-admin.mixin.js';
export default{
    mixins:[components,admin],
    components:{
        modalForm,
        selectMs,
        tabsMs
    },
    computed:{
        adskelet(){
            let result = ''
            switch (this.skelet){
                case 'skeletDeputiesAndManagers':
                    result = 'adDoctorAll'
                break
                case 'skeletMainDostor':
                    result = 'adDoctorAll'
                break
                case 'skeletOffices':
                    result = 'ad'+'skeletInformation'
                break;
                default:
                    result = 'ad'+this.skelet
                break
            }
             
            return result;
        }
    },
    watch:{
        // showForm(){
        //      axios
        //         .get('https://mosp51.ru/api/skeleton?path='+this.$route.fullPath)
        //         .then(response=>{
        //             this.skeleton = response.data.find(e=>{return e.component_name = this.skelet})
        //             console.log(this.skeleton,this.skelet,'skeleton' )
        //         }) 
        // },

    },
    mounted(){
        axios
            .get('https://mosp51.ru/api/directory?id=6')
            .then(response=>{
                this.arraySkelet = response.data
            })
           
      
    },
    methods:{
        up(){
            axios
                .post('https://mosp51.ru/api/skelet/up',{id:this.params[2]})
                .then(response=>{
                    if(response.status == 200){
                       console.log(0)
                    }
                })
        },
        down(){
            axios
                .post('https://mosp51.ru/api/skelet/down',{id:this.params[2]})
                .then(response=>{
                    if(response.status == 200){
                       console.log(0)
                    }
                })
        },
        save(){
            this.inSave = ! this.inSave
        },  
        tabClick(e){
            this.tab = e
        },
        addSkelet(){
            this.title = 'Добавить секцию'
            this.showForm = true
            this.disabledSkilet = false
        },
        editSkelet(){   
            this.title = 'Изменить секцию'
            this.showForm = true
            this.disabledSkilet = true
        },
    },
    props:{
        typeTols:{type:String},
        params:{type:Array,default(){
            return ['','','']
        }
    }
    },
    data(){
        return{
            tabs:['Предпросмотр','Настройки'],
            tab:'Предпросмотр',
            arraySkelet:[],
            skelet:this.typeTols,
            showForm:false,
            title:'Добавить секцию',
            refs:null,
            inSave:false,
            remove:false,
            skeleton:[],
            disabledSkilet:false,
        }
    }
}
</script>
<style>
.admin-menu-tols{
    display: flex;
    gap: 20px;
    flex-direction: row !important;
    background-color: var(--background);
}
.admin-menu-tols>button{
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin-bottom: 10px;
    text-decoration: underline;
    color: #175472;

}
.admin-menu-tols>button:hover{
    color: #007BB8;
}   
.admin-tols .modal-form{
    width:1320px ;
    border-radius: 10px;
    padding: 32px;
    height: fit-content;
    max-height: calc(100vh - 130px) ;
}
.admin-tols .tabs_panel>div{
    height: calc(100dvh - 295px);
    overflow: auto;
}


.admin-tols .modal-form h2{
    font-size: 26px;
    display: flex;
    gap: 20px;
    margin: 0;
    margin-bottom: 20px;
}
.admin-tols .modal-form .close {
  border: none;
  background-color: transparent;
  position: absolute;
  right: 32px;
  top: 32px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.admin-tols .modal-form .close::before, 
.admin-tols .modal-form .close::after {
  content: '';
  position: absolute;
  border: 1px solid #175472;
  display: block;
  width: 20px;
  border-radius: 10px;
  transform: rotate(45deg);
}
.admin-tols .modal-form .close::before {
  transform: rotate(-45deg);
}
.admin-tols .modal-form .frame-padding>h2,
.admin-tols .modal-form .frame-padding>h3{
    margin: 0;
}
.admin-tols .main{
    margin: 0;
    padding: 20px 0 !important;
}

.admin-tols .admin__button button{
    box-sizing: border-box;
    border: solid 2px #175472;
    color: #0D3041;
    border-radius: 10px;
    background-color: var(--background);
    font-weight: 401;
    height: 100%;
    width: 100%;
    font-size: 14px;
    cursor: pointer;
    line-height: 130%;
    font-family: Rubik;
    height: 40px;
}
.admin-tols .admin__button{
    margin-top: 10px;
    display: flex;
    gap: 20px;
}

.admin-tols section.html__panel{
    margin: 20px;
}
</style>